import type { EvidenceClass } from "../domain";

const entries: Array<{ key: EvidenceClass; label: string; description: string }> = [
  { key: "official", label: "Official", description: "Direct first-party release or artifact" },
  { key: "independent", label: "Independent", description: "Verified outside the originating organization" },
  { key: "vendor_claim", label: "Vendor claim", description: "Performance assertion awaiting corroboration" },
  { key: "rumor", label: "Rumor", description: "Unconfirmed or contradictory reporting" },
];

export const EvidenceLegend = () => (
  <div className="evidence-legend" aria-label="Evidence classes">
    {entries.map((entry) => (
      <div className="legend-row" key={entry.key}>
        <span className={`evidence-dot evidence-${entry.key}`} aria-hidden="true" />
        <strong>{entry.label}</strong>
        <span>{entry.description}</span>
      </div>
    ))}
  </div>
);

